import React, { FC, PropsWithChildren, useContext } from 'react';
import { content, text } from './styles';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { OrientationContext } from '../../service-card';

type Props = {
  title: string;
  className?: string;
} & PropsWithChildren;

export const ServiceCardContent: FC<Props> = ({ title, children, className }) => {
  const vertical = useContext(OrientationContext);
  return (
    <div className={cx(className, !vertical ? content : null)}>
      {children}
      <Typography variant="s" size="body_long" color="text-primary" className={text}>
        {title}
      </Typography>
    </div>
  );
};
